import { useEffect, useState } from "react";
import { audio } from "./audio";

/**
 * Subscribe to the audio layer's "a scripted line is currently being narrated"
 * flag. Components gate their advance buttons (Continue / Next / Post) on this so
 * the learner can't skip ahead before the voice finishes.
 */
export function useSpeaking(): boolean {
  const [s, setS] = useState<boolean>(() => audio.isSpeaking());
  useEffect(() => audio.subscribeSpeaking(setS), []);
  return s;
}
